export default {
  'ssoModal.header': '<b>Caution:</b> You are about to leave this site.',
  'ssoModal.content':
    "By clicking 'Continue' below, you will be directed to our 3rd party vendor site.",
  'ssoModal.noLogin': "Don't have a login?",
  'ssoModal.enrollNow': 'Enroll Now',
  'ssoModal.loginTo': 'Log in to',
  'ssoModal.accounts': 'Accounts',
  'ssoModal.customers': 'Customers'
};
